import { render, staticRenderFns } from "./ButtonRXS.vue?vue&type=template&id=ba0269ec&"
import script from "./ButtonRXS.vue?vue&type=script&lang=js&"
export * from "./ButtonRXS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports